import { create } from "zustand";
import axios from "axios";

export interface ISettings {
  version: string;
  apiBaseUrl: string;
  helpUrl: string;
  oktaIssuerInternal: string;
  oktaClientIdInternal: string;
  oktaIssuerExternal: string;
  oktaClientIdExternal: string;
  myEmersonLogOnUrl: string;
  myEmersonLogOutUrl: string;
}

type SettingsStore = {
  settings: ISettings;
  fetchSettings: () => Promise<void>;
};

const useSettingsStore = create<SettingsStore>((set, get) => ({
  settings: {
    version: "",
    apiBaseUrl: "",
    helpUrl: "",
    oktaIssuerInternal: "",
    oktaClientIdInternal: "",
    oktaIssuerExternal: "",
    oktaClientIdExternal: "",
    myEmersonLogOnUrl: "",
    myEmersonLogOutUrl: "",
    },
  fetchSettings: async () => {
    try {
      const baseUrl = window.location.origin;
      const response = await axios.get(`${baseUrl}/api/startup/configuration`);
      set((state) => ({
        settings: response.data,
      }));
    } catch (err) {
      console.log("fetchSettings threw an error", err);
    }
  },
}));

export default useSettingsStore;
